import { Component, OnInit } from '@angular/core';
import { ToastService } from '@core/services';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  standalone: false
})
export class ToastComponent implements OnInit {
  faExclamationCircle = faExclamationCircle;

  constructor(public ToastService: ToastService) { }

  ngOnInit(): void {

  }

}
